import http from "./axios";

export const uploadFile = file => {
    let formData = new FormData();
    formData.append('file', file);
    return http.post('/files/upload', formData);
};
